import React, { useEffect, useState } from "react";
import { Table, Image } from "antd";
import { useCustomerList } from "../../api/customer";

type customersTableProps = {
  searchText: string;
};

const customersColumn = [
  {
    title: "No.",
    width: 20,
    render: (text: string, record: any, index: number) => <b>#{index + 1}</b>,
  },
  {
    dataIndex: "fullName",
    title: "Full name",
    render: (text: string, record: any) => {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: 400,
            fontSize: 15,
            gap: 12,
          }}
        >
          <Image
            src={record.photo}
            style={{ width: 30, aspectRatio: 1, borderRadius: 50 }}
          />
          {record.fullName}
        </div>
      );
    },
  },
  {
    dataIndex: "birthDate",
    title: "Birth date",
  },
  {
    dataIndex: "gender",
    title: "Gender",
  },
  {
    dataIndex: "phoneNumber",
    title: "Phone No.",
  },
  {
    dataIndex: "address",
    title: "Address",
    render: (_address: string, record: any) => {
      const address = JSON.parse(_address);
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: 400,
            fontSize: 15,
            gap: 12,
          }}
        >
          {`${address.region} ${address.zone} ${address.woreda} ${address.kebele}`}
        </div>
      );
    },
  },
];



const CustomersTable: React.FC<customersTableProps> = ({ searchText }) => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  // Fetch data from API using updated pagination
  const { data: customers, isLoading } = useCustomerList(
    searchText,
    pagination.current - 1, // Convert to zero-based index
    pagination.pageSize
  );

  // Update tableData & pagination when API response changes
  useEffect(() => {
    if (customers?.data?.content) {
      setTableData(customers.data.content);
      setPagination((prev) => ({
        ...prev,
        total: customers.data.totalElements, 
        current: customers.data.number + 1, 
        pageSize: customers.data.size, 
      }));
    }
  }, [customers]);



  const handleTableChange = (newPagination: any) => {
    setPagination({
      ...newPagination,
      current: newPagination.current, // Update page number
      pageSize: newPagination.pageSize, // Update page size
    });
  };

  return (
    <Table
    style={{
      cursor: "pointer",
      position: "relative",
      zIndex: 100,
      overflowY: "hidden",
    }}
    scroll={{ y: 600 }}
      dataSource={tableData}
      columns={customersColumn}
      loading={isLoading}
      pagination={{
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: pagination.total,
        showSizeChanger: true,
        showTotal: (total) => `Total ${total} customers`,
      }}
      onChange={handleTableChange}
      rowKey="customerId"
    />
  );
};

export default CustomersTable;
